<template>
  <div id="app">
    <!-- 根据路由meta决定是否显示公共头部 -->
    <AppHeader v-if="shouldShowHeader" :fixed="true" />

    <!-- <div class="main-content">
      <router-view />
    </div> -->
    <div class="main-content">
      <!-- 缓存需要保持状态的页面 -->
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <!-- 不缓存的页面直接渲染 -->
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
    <!-- 根据路由meta决定是否显示公共尾部 -->
    <AppFooter v-if="shouldShowFooter" />
  </div>
</template>

<script>
import AppHeader from "./components/Header.vue";
import AppFooter from "./components/Footer.vue";
export default {
  name: "App",
  components: {
    AppHeader,
    AppFooter,
  },
  computed: {
    shouldShowHeader() {
      // 默认继承，除非路由meta中明确设置inheritHeader为false
      return this.$route.meta.inheritHeader !== false;
    },
    shouldShowFooter() {
      // 默认继承，除非路由meta中明确设置inheritFooter为false
      return this.$route.meta.inheritFooter !== false;
    },
  },
};
</script>

<style>
body {
  margin: 0;
  padding: 0;
  overflow: visible !important;
}
.main-content {
  overflow: hidden;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  height: 80px !important;
}

.el-footer {
  height: 100px !important;
}
</style>
